"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerNoteVisibility = exports.SignupReminderType = exports.ReservationStatus = void 0;
/* eslint-disable no-shadow */
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["PENDING"] = "PENDING";
    ReservationStatus["DELETED"] = "DELETED";
    ReservationStatus["DONE"] = "DONE";
    ReservationStatus["REFUNDED"] = "REFUNDED";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
var SignupReminderType;
(function (SignupReminderType) {
    SignupReminderType["INITIAL"] = "INITIAL";
    SignupReminderType["FIRST"] = "FIRST";
    SignupReminderType["SECOND"] = "SECOND";
    SignupReminderType["THIRD"] = "THIRD";
    SignupReminderType["FOURTH"] = "FOURTH";
    SignupReminderType["UNKNOWN"] = "UNKNOWN";
})(SignupReminderType = exports.SignupReminderType || (exports.SignupReminderType = {}));
var CustomerNoteVisibility;
(function (CustomerNoteVisibility) {
    CustomerNoteVisibility["PRIVATE"] = "PRIVATE";
    CustomerNoteVisibility["PUBLIC"] = "PUBLIC";
    CustomerNoteVisibility["INTERNALLY_SHARED"] = "INTERNALLY_SHARED";
})(CustomerNoteVisibility = exports.CustomerNoteVisibility || (exports.CustomerNoteVisibility = {}));
